module.exports = __webpack_public_path__ + "img/coin-badge.b236bd94.jpg";